import { useEdition } from './edition/EditionProvider'
import { ChooseChowApp } from './features/choosechow/ChooseChowApp'
import { ChowDashApp } from './features/chowdash/ChowDashApp'
import { DeployBanner } from './components/DeployBanner'
import { LiveStatusBanner } from './components/LiveStatusBanner'
import { useRenderQuality } from './lib/renderQuality'
import { useLocation } from 'react-router-dom'

/**
 * Edition router: one codebase, two products. The active edition (resolved from
 * `?edition=` by EditionProvider) selects which product app — and therefore
 * which dock, routes, accent, and content — is mounted. `chow` (dev) defaults to
 * the ChooseChow surface.
 */
function App() {
  const { edition } = useEdition()
  const { pathname } = useLocation()
  useRenderQuality()
  const isOpsRoute = pathname === '/ops' || pathname.startsWith('/ops/')
  return (
    <>
      {edition === 'chowdash' && !isOpsRoute ? <ChowDashApp /> : <ChooseChowApp />}
      <DeployBanner />
      <LiveStatusBanner />
    </>
  )
}

export default App
